<script>
export default {
    name: 'IconBurger'
}
</script>
<template>
    <svg
        class="base-icon icon-burger"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M56 46v6H8v-6h48zm0-17v6H8v-6h48zm0-17v6H8v-6h48z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
